module.exports = __webpack_public_path__ + "static/media/banner2.42c567f0.png";